module.exports = __webpack_public_path__ + "img/beans@2x.png";